import { lazy } from "react";

// Layout - DO NOT lazy load the layout, it should persist across pages
import MainLayout from "../components/layouts/MainLayout";
import ProtectedRoute from "../components/common/ProtectedRoute";

// Lazy load components
const HomePage = lazy(() => import("../pages/home/page"));
const ProductsPage = lazy(() => import("../pages/products/page"));
const CollectionsPage = lazy(() => import("../pages/collections/page"));
const BrandsPage = lazy(() => import("../pages/brands/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const ProductDetailPage = lazy(() => import("../pages/product-detail/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const CartPage = lazy(() => import("../pages/cart/page"));
const CheckoutPage = lazy(() => import("../pages/checkout/page"));
const AccountPage = lazy(() => import("../pages/account/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

// Category pages
const CategoriesPage = lazy(() => import("../pages/categories/page"));
const SubCategoriesPage = lazy(() => import("../pages/categories/[categorySlug]/page"));
const CategoryProductsPage = lazy(() => import("../pages/categories/[categorySlug]/[subCategorySlug]/products/page"));

// Logo customization pages
const LogoPositionPage = lazy(() => import("../pages/logo/position/page"));
const LogoTypePage = lazy(() => import("../pages/logo/type/page"));
const LogoUploadPage = lazy(() => import("../pages/logo/upload/page"));
const LogoSummaryPage = lazy(() => import("../pages/logo/summary/page"));

// Bundle pages
const BundlesPage = lazy(() => import("../pages/bundles/page"));
const BundleDetailPage = lazy(() => import("../pages/bundles/detail/page"));

// Shared basket page
const SharedBasketPage = lazy(() => import("../pages/shared-basket/page"));

// Legal pages
const TermsAndConditionsPage = lazy(() => import("../pages/terms/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));

const routes = [
    {
        path: "/",
        element: <MainLayout />,
        children: [
            {
                index: true,
                element: <HomePage />,
            },
            {
                path: "products",
                element: <ProductsPage />,
            },
            {
                path: "categories",
                element: <CategoriesPage />,
            },
            {
                path: "categories/:categorySlug",
                element: <SubCategoriesPage />,
            },
            {
                path: "categories/:categorySlug/:subCategorySlug/products",
                element: <CategoryProductsPage />,
            },
            {
                path: "collections",
                element: <CollectionsPage />,
            },
            {
                path: "brands",
                element: <BrandsPage />,
            },
            {
                path: "contact",
                element: <ContactPage />,
            },
            {
                path: "product/:slug",
                element: <ProductDetailPage />,
            },
            {
                path: "about",
                element: <AboutPage />,
            },
            {
                path: "cart",
                element: <CartPage />,
            },
            {
                path: "checkout",
                element: <CheckoutPage />,
            },
            {
                path: "account",
                element: (
                    <ProtectedRoute>
                        <AccountPage />
                    </ProtectedRoute>
                ),
                children: [
                    {
                        index: true,
                        element: null, // Will redirect to dashboard
                    },
                    {
                        path: "dashboard",
                        element: null,
                    },
                    {
                        path: "profile",
                        element: null,
                    },
                    {
                        path: "addresses",
                        element: null,
                    },
                    {
                        path: "orders",
                        element: null,
                    },
                    {
                        path: "orders/:orderId",
                        element: null,
                    },
                    {
                        path: "wishlist",
                        element: null,
                    },
                    {
                        path: "notifications",
                        element: null,
                    },
                    {
                        path: "support",
                        element: null,
                    },
                ],
            },
            {
                path: "bundles",
                element: <BundlesPage />,
            },
            {
                path: "bundles/:slug",
                element: <BundleDetailPage />,
            },
            {
                path: "shared-basket/:token",
                element: <SharedBasketPage />,
            },
            {
                path: "terms-and-conditions",
                element: <TermsAndConditionsPage />,
            },
            {
                path: "privacy-policy",
                element: <PrivacyPolicyPage />,
            },
            {
                path: "*",
                element: <NotFoundPage />,
            },
        ],
    },
];

export default routes;
